import React, { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { useUser } from "../Contexts/UserContext";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import CustomDatePicker from "./CustomDatePicker";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const month = [
  { id: 1, label: "JAN" },
  { id: 2, label: "FEB" },
];
const ReportsSubmission = ({
  title,
  selectedData,
  setSelectedData,
  handleFetchReports,
  reportTypeList,
}) => {
  const { user } = useUser();
  const { ClientId } = user;

  const OnDataSelect = (key, value) => {
    if (value === null) return;
    setSelectedData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Stack mt={1} mb={1} textAlign="start">
        <h2
          className="heading2"
          style={{
            fontSize: "14px",
            fontWeight: "500",
            padding: "0",
            lineHeight: "1px",
            margin: "0px 0px 0px 0vw",
            letterSpacing: "2px",
            textTransform: "uppercase",
            color: "#aaaaaa",
            fontFamily: "Poppins, sans-serif",
          }}
        >
          {title}
          <style>
            {`
      .heading2::after {
        content: "";
    width: 120px;
    height: 1px;
    display: inline-block;
    background: #D10101;
    margin: 4px 10px;
      }
    `}
          </style>
        </h2>
      </Stack>
      <Box
        sx={{
          p: 2,
          mb: 2,
          bgcolor: "background.default",
          boxShadow: 3,
          borderRadius: 2,
          border: "2px solid #D10101",
        }}
      >
        <Stack
          width="100%"
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Autocomplete
            size="small"
            options={reportTypeList || []}
            getOptionLabel={(option) => option.NAME}
            getOptionSelected={(option, value) => option.ID === value.ID}
            renderInput={(params) => (
              <TextField {...params} label="Report" size="small" />
            )}
            value={selectedData.reportObj}
            onChange={(e, value) => {
              OnDataSelect("reportObj", value);
            }}
            sx={{
              minWidth: "22%",
            }}
          />

          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={() => handleFetchReports()}
            disabled={!selectedData.reportObj}
            sx={{
              fontSize: "12px",
            }}
          >
            find
          </Button>
        </Stack>
      </Box>
    </LocalizationProvider>
  );
};

export default ReportsSubmission;
